export default __webpack_public_path__ + "static/openText-thumbnail-ae387ef4c1b711907314b226eb73a6e4.png";